import React,{ useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import './filter.scss'
import TimePicker from 'react-time-picker';
import DatePicker from 'react-datepicker';
import { getService,dashboardProjectsData } from '../../services/auth.service';
const Filter = (props) => {

    const [selectedDate, setSelectedDate] = useState(null);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [timePeriod, setTimePeriod] = useState();
    const [services, setServices] = useState([]);
    const [selectedOption, setSelectedOption] = useState();
    const [status,setStatus]=useState(1)


    const handleMonthChange = (event) => {
        // console.log(event.target.value,"event.target.value tiem")
        setTimePeriod(event.target.value);
        // console.log(timePeriod,"timePeriod")
    };

    const timePeriods = [
        { value: "1 week", label: "1 Week" },
        { value: "1 month", label: "1 Month" },
        { value: "3 month", label: "3 Month" },
        // { value: "6 month", label: "6 Month" }
    ]

    const handleDateChange = (date) => {
      setSelectedDate(date);
    };

    const handleDropdownChange = (event) => {
        const selectedOption = [{"id": event.target.value, "value": "0"}];
        // console.log(event.target.value,"event.target.value")
        setSelectedOption(event.target.value);
      };

    const filter =async()=>{
        // console.log("filter",startDate,endDate,timePeriod,selectedOption)
        let res = await dashboardProjectsData(startDate,endDate,timePeriod,selectedOption);
        // console.log(res,"res for daashboard")
        props.filterDataParent(res)
        setStatus(2)

        if(status==2){
        // console.log(status,"insidddd")
        props.setfilterModal(false)

        }
        // console.log(status,"insidddd out")

    }

    const fetchData = async () => {
      try {
        let res = await getService();
        // console.log(res, "getservice");
        setServices(res.data.services);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    useEffect(() => {
      const currentDate = new Date();
      const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
      const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
  
      setStartDate(firstDayOfMonth);
      setEndDate(lastDayOfMonth);
      filter()
        fetchData(); 
      }, []); // Add an empty dependency array if you want the effect to run once when the component mounts
    
    return (
        <>
            <Modal
                size="sm"
                show={props.filterModal}
                onHide={() => props.setfilterModal(false)}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                </Modal.Header>
                <Form className='modal-form-wrapper' >
                <label>Select a start date:</label>
                <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} />

                <label>Select a end date:</label>
                <DatePicker selected={endDate} onChange={(date) => setEndDate(date)} />

                <select id="month" onChange={handleMonthChange} value={timePeriod}>
                {timePeriods.map((timePeriods) => (
                    <option key={timePeriods.value} value={timePeriods.value}>
                        {timePeriods.label}
                    </option>
                ))}
            </select>

            <select aria-label="Select your expertise or the services" onChange={handleDropdownChange}>

                        {services.map(service => (
                          <option key={service._id} value={service._id}>
                            {service.name}
                          </option>
                        ))}

                      </select>
                       
                        <div className='form-footer text-center w-100 mb-2' onClick={filter} >Filter</div>
                    </Form>
            </Modal>
        </>
    )
}

export default Filter